import { TextField } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import moment from 'moment';
import ApiService from '../../functions/apiService';
import { toast } from 'react-toastify';

export default function AddNote(props) {
    const data = useSelector((state) => state.dashboardReducer.Data)
    const [saving, setSaving] = useState(false);
    const [isEdit, setIsEdit] = useState(true)

    const { register, formState: { errors }, handleSubmit, setError, setValue, getValues, watch, reset } = useForm({
        defaultValues: {
            Note: ""
        }
    });

    watch('Note')
    let onSubmit = (e) => {
        setSaving(true)
        ApiService.post('/createNotes', { ...e, Date: moment(data.date).format('YYYY-MM-DD') })
            .then(() => {
                // reset()
                setIsEdit(false)
                toast.success('Note saved successfully')
                setSaving(false)
            })
            .catch((e) => {
                toast.error(e?.data?.message)
                setSaving(false)
            })
    }

    const getNotes = () => {
        const dateArr = data.date.split('-')
        ApiService.get(`/day-notes/${dateArr[0]}/${dateArr[1]}/${dateArr[2]}`, {}, 'notes').then(({ data }) => {
            if (data.data) {
                setValue("Note", data.data.Note)
                setIsEdit(false)
            }
        }).catch((e) => console.log(e, 'errrrrrrrrrr'));
    };

    useEffect(() => {
        getNotes()
    }, [data])

    return <div className='m-3'>
        <p>Notes</p>
        <form onSubmit={handleSubmit(onSubmit)}>
            <TextField
                placeholder='Enter notes'
                {...register('Note')}
                multiline
                rows={4}
                className='w-100 my-3'
                disabled={!isEdit || !props.permission.includes('Notes_Auth')}
            />
            {(props.pages.includes('SCHEDULE_DISPLAY_NOTES') || props.permission.includes('Notes_Auth')) &&
                <>
                    <ButtonTheme disabled={isEdit} variant="filled" color='primary' className='px-5 my-3' onClick={() => setIsEdit(true)}>
                        Edit
                    </ButtonTheme>
                    <ButtonTheme disabled={!isEdit || saving || getValues('Note') == ''} type='submit' variant="filled" color='primary' className='px-5 my-3 mx-3'>
                        {saving && 'Loading...'}
                        {!saving && 'Save'}
                    </ButtonTheme>
                </>
            }
        </form>
    </div>
}
